// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swagger-ui .scheme-container {
  padding-left: 25px;
  padding-right: 10px;
}

.swagger-ui .opblock .opblock-section-header > label {
  margin-left: 8px;
}

/* Adjust the content to the right of the sidebar */
.profile-content {
  width: 100%;
}
.right-content {
  padding: 15px;
  padding-right: 30px;
  position: absolute;
  right: 0px;
  background: #ccc;
  border-top-right-radius: 10px;
}
.profile-section {
  background-color: #fff;
  padding: 25px 15px 25px 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
}

.seperator {
  width: 100%;
  border-bottom: 1px solid #ccc;
  margin-bottom: 15px;
}

.edit-profile {
  display: flex;
  justify-content: right;
  align-items: center;
  width: 44%;
}
.name-initials {
  font-weight: bold;
  font-size: 2rem;
  background: #66bf00;
  color: #fff;
  border-radius: 50%;
  padding: 10px;
  display: flex;
  margin-right: 10px;
  width: 80px;
  height: 80px;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}
.initials-side {
  padding: 30px 0 0;
  margin-right: 20px;
}
.details {
  display: inline-block;
}
.profile-user {
  font-weight: 700;
  font-size: 1.7rem;
}
.pr-user-email {
  font-size: 0.9rem;
}
.edit-profile a {
  background: #f1f7fd;
  text-transform: uppercase;
  text-decoration: none !important;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 5px;
  border-radius: 8px;
  width: 60px;
  text-align: center;
  letter-spacing: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.edit-profile a:hover {
  background: #d1e3fa;
}
.edit-profile-detail {
  display: flex;
  justify-content: right;
  align-items: center;
  width: 49%;
}
.profile-detail-section {
  background-color: #fff;
  padding: 5px 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.edit-profile-detail a {
  background: #f1f7fd;
  text-transform: uppercase;
  text-decoration: none !important;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 5px;
  border-radius: 8px;
  width: 60px;
  text-align: center;
  letter-spacing: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.edit-profile-detail a:hover {
  background: #d1e3fa;
}
.seperator {
  border-bottom: 1px solid #ccc;
  padding-bottom: 40px;
  display: flex;
}
.contact-number {
  padding-left: 2px;
  font-size: 1.2rem;
  color: #66bf00 !important;
  text-decoration: none !important;
}
img.contact-images {
  display: inline-block;
  margin-top: -12px;
  width: 20px;
}
.contact-content {
  font-size: 1.3rem;
}
.custom-color {
  top: -30px;
}
`, "",{"version":3,"sources":["webpack://./src/views/contactUs/contactUs.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ","sourcesContent":[".swagger-ui .scheme-container {\n  padding-left: 25px;\n  padding-right: 10px;\n}\n\n.swagger-ui .opblock .opblock-section-header > label {\n  margin-left: 8px;\n}\n\n/* Adjust the content to the right of the sidebar */\n.profile-content {\n  width: 100%;\n}\n.right-content {\n  padding: 15px;\n  padding-right: 30px;\n  position: absolute;\n  right: 0px;\n  background: #ccc;\n  border-top-right-radius: 10px;\n}\n.profile-section {\n  background-color: #fff;\n  padding: 25px 15px 25px 30px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.seperator {\n  width: 100%;\n  border-bottom: 1px solid #ccc;\n  margin-bottom: 15px;\n}\n\n.edit-profile {\n  display: flex;\n  justify-content: right;\n  align-items: center;\n  width: 44%;\n}\n.name-initials {\n  font-weight: bold;\n  font-size: 2rem;\n  background: #66bf00;\n  color: #fff;\n  border-radius: 50%;\n  padding: 10px;\n  display: flex;\n  margin-right: 10px;\n  width: 80px;\n  height: 80px;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 30px;\n}\n.initials-side {\n  padding: 30px 0 0;\n  margin-right: 20px;\n}\n.details {\n  display: inline-block;\n}\n.profile-user {\n  font-weight: 700;\n  font-size: 1.7rem;\n}\n.pr-user-email {\n  font-size: 0.9rem;\n}\n.edit-profile a {\n  background: #f1f7fd;\n  text-transform: uppercase;\n  text-decoration: none !important;\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 5px;\n  border-radius: 8px;\n  width: 60px;\n  text-align: center;\n  letter-spacing: 1px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.edit-profile a:hover {\n  background: #d1e3fa;\n}\n.edit-profile-detail {\n  display: flex;\n  justify-content: right;\n  align-items: center;\n  width: 49%;\n}\n.profile-detail-section {\n  background-color: #fff;\n  padding: 5px 10px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n}\n.edit-profile-detail a {\n  background: #f1f7fd;\n  text-transform: uppercase;\n  text-decoration: none !important;\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 5px;\n  border-radius: 8px;\n  width: 60px;\n  text-align: center;\n  letter-spacing: 1px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.edit-profile-detail a:hover {\n  background: #d1e3fa;\n}\n.seperator {\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 40px;\n  display: flex;\n}\n.contact-number {\n  padding-left: 2px;\n  font-size: 1.2rem;\n  color: #66bf00 !important;\n  text-decoration: none !important;\n}\nimg.contact-images {\n  display: inline-block;\n  margin-top: -12px;\n  width: 20px;\n}\n.contact-content {\n  font-size: 1.3rem;\n}\n.custom-color {\n  top: -30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
